$(document).ready(function() {

    if($('.alert').length > 0) {

        $('.alert').show();
        setTimeout(function() {
             $('.alert').addClass('alert--active');
             $('.quick-add-visit-icon').addClass('quick-add-visit-icon--active');

            setTimeout(function() {
                 $('.alert').removeClass('alert--active');
                $('.quick-add-visit-icon').removeClass('quick-add-visit-icon--active');
            }, 3500)
        }, 500);

    }

});


// WEBPACK FOOTER //
// ./alert.js